import React, { Component } from 'react';
import { Collapse, Navbar, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import FontSizeChanger from 'react-font-size-changer';
import '../../assets/styles/NavMenu.css';
import agricultureDarkLogo from '../../assets/images/agriculture-logo-dark.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faTwitter, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons"
import { faBars, faDownload } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index';
import KrishiMapper from '../../assets/images/krishiMapper.png';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    skipToContent() {
       
        var targetElement = document.getElementById('skipId')
  var {top, left} = targetElement.getBoundingClientRect() //get position on screen
  window.scrollTo(top + window.scrollY, left + window.scrollX)

    }

    render() {
        return (

            <>
           {/* <a href="https://krishimapper.dac.gov.in/ApkFiles/krishimapperV2.apk" download className='playstoreApp text-center' target={'_blank'}><FontAwesomeIcon icon={faDownload} /> <span>Download App <br/></span><span className='text-normalpublish'>Publish Date:01-11-2023</span></a> */}
            <div className="headerSection header-area" id="navbar_top">
                <div className="header-top d-none d-sm-block">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="d-flex justify-content-between flex-wrap align-items-center">
                                    <div className="header-info-right d-none d-md-block">
                                        <ul className="header-social">
                                            {<li><NavLink className="text-dark hindiCont" to="#mainsection">भारत सरकार | कृषि एवं किसान कल्याण मंत्रालय </NavLink></li>}
                                        </ul>
                                    </div>
                                    <div className="header-info-right d-none d-md-block">
                                        <ul className="header-social">
                                        <li>  <NavLink tag={Link} className="text-dark" to="/" onClick={this.skipToContent}>  Skip To Main Content </NavLink> </li>
                                        <li> 
                                            <a href="https://www.facebook.com/agriGoI/" className='textFacebook' target={'_blank'}><i><FontAwesomeIcon icon={faFacebook} /></i></a>
                                            </li>
                                            
                                            <li>
                                            <a href="https://twitter.com/i/flow/login?redirect_after_login=%2Fagrigoi" target={'_blank'} className='textTwitter'><i><FontAwesomeIcon icon={faTwitter} /></i> </a>
                                                 </li>
                                            <li> 
                                                <a href="https://www.instagram.com/agrigoi/" className="textinstagram" target={'_blank'}><i><FontAwesomeIcon icon={faInstagram} /></i></a>
                                               </li>
                                            <li>  
                                                <a href="https://www.youtube.com/@AgriGoI" className="textyoutube" target={'_blank'}><i><FontAwesomeIcon icon={faYoutube} /></i></a>
                                               </li>
                                            <li><FontSizeChanger
                                                targets={['#target .content']}
                                                onChange={(element, newValue, oldValue) => {
                                    
                                                }}
                                                options={{
                                                    stepSize:2,
                                                    range: 2
                                                }}
                                                customButtons={{
                                                    up: <NavLink tag={Link} className="text-dark" to="/"> A+</NavLink>,
                                                    down: <NavLink tag={Link} className="text-dark" to="/">A-</NavLink>,
                                                    default: <NavLink tag={Link} className="text-dark" to="/">A</NavLink>,

                                                }}
                                            /></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
          
                <div className="container-fluid agriculture-section" >
                    <div className="row">
                        <div className="col-md-9 col-xs-12 logo-content align-self-start">
                            <a href="/">
                                <div className="logo-division">
                                    <img src={agricultureDarkLogo} alt="agriculture government of india" className="agriculture-logo" />

                                    <div>
                                        <ul>
                                            <li className="krishi_heading" lang="hi">कृषि एवं किसान कल्याण विभाग</li>
                                            <li className="department_heading" lang="en">DEPARTMENT OF AGRICULTURE &amp; FARMERS WELFARE <br /><h6>MINISTRY OF AGRICULTURE &amp; FARMERS WELFARE</h6></li>
                                            <li className="department_heading-tow" lang="en">
                                                {/*<h6 className="logo-text logo-text-one">*/}
                                                {/*    <span>भारत सरकार</span>*/}
                                                {/*    <span>GOVERNMENT OF INDIA</span>*/}
                                                {/*</h6>*/}
                                                <h6 className="logo-text logo-text-two">
                                                 {/*   <span>कृषि एवं किसान कल्याण मंत्रालय</span>*/}
                                                    <span></span>
                                                </h6>
                                            </li>
                                        </ul>

                                    </div>
                                </div>
                            </a>
                        </div>

                        <div className="col-md-3 col-xs-12">
                            {/*  <img src={logo_G20} className="float-right " />*/}
                            <img src={KrishiMapper} className="float-right gLogo" alt='KrishiMApper Logo' />

                        </div>
                    </div>
                </div>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow" >
                    <div className="container-fluid Menus">
                        
                        <NavbarToggler onClick={this.toggleNavbar} className="mr-2"><FontAwesomeIcon icon={faBars} /></NavbarToggler>
                        <Collapse className="d-sm-inline-flex collapse navbar-collapse" isOpen={!this.state.collapsed} navbar>
                            <ul className="navbar-nav flex-grow mobileview">
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/">Home</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/Aboutus">About Us</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/Schemes">Schemes</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to={{pathname:"/MapLogin", props:"map"}}>Dashboard</NavLink>
                                </NavItem> 
                                {/* <NavItem>
                                    <a   className="text-dark nav-link"   href="https://app.powerbi.com/view?r=eyJrIjoiNGI1YWJlYTUtZjM1NC00NGM4LTk5MmMtMmMyZTQ3OWQxMGNkIiwidCI6IjRkYTc4NmI2LWQzNDQtNDRmYS1iMWYwLWUxYTgxMjY0ZDBhOSJ9" target="_blank" >ANALYTICS DASHBOARD</a>
                                </NavItem> */}
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/Downloads">Downloads</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/Contactus">Contact Us</NavLink>
                                </NavItem>
                                <NavItem className="mobileNav">
                                    <NavLink tag={Link} className="text-dark" to="/Login">Login</NavLink>
                                </NavItem>
                            </ul>
                            <ul className="navbar-nav d-flex ms-auto mobileview">
                                <NavItem className="loginBtns">
                                    <NavLink tag={Link} className="text-dark" to="/Login">Login</NavLink>
                                </NavItem>
                              
                            </ul>
                        </Collapse>
                  
                    </div>
                </Navbar>
            </div>
            </>
        );
    }
}
